


























import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import PanelWithStreamEditor from '@/components/Live/PanelWithStreamEditor.vue';

import {
  getLive,
  deleteStream,
} from '@/api/index';

const PanelWithStreamEditorGroup = defineComponent({
  components: {
    CommonModalWithPreset,
    PanelWithStreamEditor,
  },
  setup() {
    const { route, router } = useRouter();

    const streams = ref([{
      id: -1,
      name: '',
      streamUrl: '',
      streamType: 'YOUTUBE',
      language: 'TH',
      order: 1,
      button: '',
      button_en: '',
      index: 0,
    }]);

    const callGetLive = async () => {
      const { streams: streamsData } = await getLive(route.value.params.liveId);
      streams.value = streamsData.map((stream: any, index: number) => ({
        id: stream.id,
        name: stream.name,
        streamType: stream.stream_type,
        streamUrl: stream.stream_url,
        language: stream.language,
        order: stream.order || 1,
        button: stream.button,
        button_en: stream.button_en,
        index,
        thumbnailUrl: stream.preview,
      }));
    };

    onMounted(async () => {
      await callGetLive();
    });

    function addStreamTemplate() {
      streams.value.push({
        id: -1,
        name: '',
        streamUrl: '',
        streamType: 'YOUTUBE',
        language: 'TH',
        order: 1,
        button: '',
        button_en: '',
        index: streams.value.length,
      });
    }

    // Delete fn
    const deleteItemModal = ref(null);
    const openDeleteItemModal = (id: number | string) => {
      (deleteItemModal.value as any).compose({
        id,
        action: 'ลบ',
        entity: 'Stream',
        body: 'เป็นการลบ<br>Stream<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้',
      });
    };
    const deleteItemAction = async (id: number) => {
      const result = await deleteStream(id);
      await callGetLive();
    };

    async function removeStreamItem(id: number | string, index: number) {
      if (id > -1) {
        openDeleteItemModal(id);
      } else streams.value.splice(index, 1);
    }

    watch(() => route.value.params.liveId, async (newVal, oldVal) => {
      if (newVal !== oldVal) await callGetLive();
    });

    return {
      callGetLive,
      streams,
      addStreamTemplate,
      removeStreamItem,

      deleteItemModal,
      openDeleteItemModal,
      deleteItemAction,
    };
  },
});

export default PanelWithStreamEditorGroup;
